import styled from 'styled-components';

export const Wrapper = styled.div`
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
`;

export const AddButton = styled.button`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => p.theme.colors.primary.main};
  border-radius: 50%;
  border: none;
  color: #fff;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
    transition: opacity 0.2s;
  }
`;
